import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  url: string;
  image?: string;
}

const DEFAULT_IMAGE = "https://b8ild.fr/logo-b8ild.png";

// Valeurs par défaut de index.html pour restaurer au démontage
const DEFAULTS = {
  title: "B8ild — Pilotage rentabilité chantier BTP",
  description: "B8ild, logiciel 100% dédié aux artisans et PME du BTP, calcule automatiquement votre rentabilité en temps réel et vous alerte 7, 3, 1 jour avant le déficit.",
  url: "https://b8ild.fr/",
  image: "/logo-b8ild.png",
};

function setMetaTag(selector: string, attribute: string, value: string) {
  const el = document.querySelector(selector);
  if (el) {
    el.setAttribute(attribute, value);
  }
}

export function usePageMeta({ title, description, url, image }: PageMeta) {
  useEffect(() => {
    const ogImage = image || DEFAULT_IMAGE;

    // Title
    document.title = title;
    setMetaTag('meta[name="title"]', "content", title);

    // Description
    setMetaTag('meta[name="description"]', "content", description);

    // Open Graph
    setMetaTag('meta[property="og:title"]', "content", title);
    setMetaTag('meta[property="og:description"]', "content", description);
    setMetaTag('meta[property="og:url"]', "content", url);
    setMetaTag('meta[property="og:image"]', "content", ogImage);

    // Twitter
    setMetaTag('meta[name="twitter:title"]', "content", title);
    setMetaTag('meta[name="twitter:description"]', "content", description);
    setMetaTag('meta[name="twitter:image"]', "content", ogImage);

    // Canonical
    setMetaTag('link[rel="canonical"]', "href", url);

    // Restaurer les valeurs par défaut au démontage
    return () => {
      document.title = DEFAULTS.title;
      setMetaTag('meta[name="title"]', "content", DEFAULTS.title);
      setMetaTag('meta[name="description"]', "content", DEFAULTS.description);
      setMetaTag('meta[property="og:title"]', "content", DEFAULTS.title);
      setMetaTag('meta[property="og:description"]', "content", DEFAULTS.description);
      setMetaTag('meta[property="og:url"]', "content", DEFAULTS.url);
      setMetaTag('meta[property="og:image"]', "content", DEFAULTS.image);
      setMetaTag('meta[name="twitter:title"]', "content", DEFAULTS.title);
      setMetaTag('meta[name="twitter:description"]', "content", DEFAULTS.description);
      setMetaTag('meta[name="twitter:image"]', "content", DEFAULTS.image);
      setMetaTag('link[rel="canonical"]', "href", DEFAULTS.url);
    };
  }, [title, description, url, image]);
}
